<template>
  <div>
    <template v-if="loader && localResponsibleSquad.length === 0">
      <div class="py-5">
        <Loader size="big" />
      </div>
    </template>
    <template v-else-if="!loader && localResponsibleSquad.length === 0">
      <p class="text-center pt-5">
        Nenhum responsável informado
      </p>
    </template>
    <template v-else>
      <div class="table-responsive">
        <!--begin::Table-->
        <table class="table align-middle table-row-dashed fs-6 gy-5">
          <!--begin::Table head-->
          <thead>
            <!--begin::Table row-->
            <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
              <th class="min-w-100px">Nome</th>
              <th class="min-w-70px">Status</th>
              <th class="min-w-70px">Ações</th>
            </tr>
            <!--end::Table row-->
          </thead>
          <!--end::Table head-->
          <!--begin::Table body-->
          <tbody class="fw-semibold text-gray-600">
            <!--begin::Table row-->
            <tr v-for="(user, index) in localResponsibleSquad" :key="index">
              <td>
                <span>{{ user.user.name }}</span>
              </td>
              <td>
                <span>{{ user.is_active ? 'Ativo' : 'Inativo' }}</span>
              </td>
              <td>
                <Button
                  type="button"
                  class="btn btn-danger py-2"
                  @click="destroyResponsible(user.id)"
                  v-b-tooltip.hover title="Desativar"
                  :loading="loaderDestroy"
                >
                  <i class="fa-solid fa-xmark p-0"></i>
                </Button>
              </td>
            </tr>
            <!--end::Table row-->
          </tbody>
          <!--end::Table body-->
        </table>
      </div>
      <!--end::Table-->
      <!--end::Table-->
    </template>
    <ResponsibleSquadModal
      :companyId="companyId"
      @created="getResponsibleSquad" />
  </div>
</template>

<script>

import NotificationService from '@/modules/notifications/services/notifications-service'
import ResponsibleSquadsService from '@/modules/responsible-squads/services/responsible-squads-service'

import Loader from '@/components/common/Loader/Loader'
import ResponsibleSquadModal from '@/components/responsible-squads/ResponsibleSquadModal'

export default {
  name: 'ResponsibleSquadListTable',
  props: ['companyId', 'responsibleSquad'],
  components: {
    Loader,
    ResponsibleSquadModal
  },
  data () {
    return {
      loader: false,
      loaderDestroy: false,
      localResponsibleSquad: [],
      responsible: []
    }
  },
  created () {
    if (this.responsibleSquad) {
      this.localResponsibleSquad = this.responsibleSquad
    } else {
      this.getResponsibleSquad()
    }
  },
  watch: {
    reload (newValue) {
      if (newValue) this.reset()
    }
  },
  methods: {
    /**
     * Get responsible squad
     */
    async getResponsibleSquad () {
      if (!this.companyId) return false
      this.loader = true
      this.localResponsibleSquad = []
      try {
        const responsibleSquad = await ResponsibleSquadsService.getResponsibleSquad({
          company_id: this.companyId ?? null,
          page: 1
        })
        this.localResponsibleSquad = [...this.localResponsibleSquad, ...responsibleSquad.data]
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    /**
     * destroy
     */
    async destroyResponsible (id) {
      this.loader = true
      try {
        await ResponsibleSquadsService.destroyResponsibleSquad(id)
        const notification = {
          notification: {
            type: 'success',
            content: 'Responsável desativado com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.getResponsibleSquad()
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    /**
     * Reset and reload
     */
    reset () {
      this.page = 1
      this.localResponsibleSquad = []
      this.getResponsibleSquad()
    }
  }
}

</script>
